var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcPadGeneratorInteractionModel = require('./ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var DualRowPackageWithJOrLLeadPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(DualRowPackageWithJOrLLeadPadGeneratorInteractionModel, IpcPadGeneratorInteractionModel);
DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.$class = 'DualRowPackageWithJOrLLeadPadGeneratorInteractionModel';

module.exports = DualRowPackageWithJOrLLeadPadGeneratorInteractionModel;

DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcPadGeneratorInteractionModel.prototype.initialize.call(this);
    
    this.terminalCenterToCenterDistance = this.shadow("terminalCenterToCenterDistance",
        function() {
            return self.data.terminalCenterToCenterDistance() / self.getUnitFactor();
        },
        function(value) {
            return self.data.terminalCenterToCenterDistance(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.terminalCenterToCenterDistance, this.userSettingsModel.distanceUnit]
    );
};

DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [4, 6])];
};

DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalCenterCenterDistance = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('E2', this.LCLZ('terminalCCGap', 'Terminal Center-Center Gap'), this.terminalCenterToCenterDistance, this.userSettingsModel.distanceUnit)];
};

DualRowPackageWithJOrLLeadPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintOscL));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalCenterCenterDistance());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};